export const HDR_SKY = 'HDR_SKY';